<template>
    <div>
        <div style="
    background-color: #f8d7da;
    color: #721c24;
    padding: 15px;
    border: 1px solid #f5c6cb;
    border-radius: 5px;
    text-align: center;
    font-family: Arial, sans-serif;
    margin: 20px auto;
    max-width: 500px;
  ">
    <strong>Paiement Échoué :</strong> Nous n'avons pas pu traiter votre paiement. Veuillez réessayer ou contacter le support si le problème persiste.
    <br><br>
    <button onclick="window.location.href='https://hiropay.com/exchange'" style="
      background-color: #721c24;
      color: #ffffff;
      border: none;
      padding: 10px 20px;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
      margin-top: 10px;
    ">
      Retourner vers Hiropay
    </button>
  </div>

    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>